import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect, useCallback } from 'react';
import ChannelCarousel from './channel'

import img1 from '../assets/cover/series/1.webp'
import img2 from '../assets/cover/series/2.webp'
import img3 from '../assets/cover/series/3.webp'
import img4 from '../assets/cover/series/4.webp'
import img5 from '../assets/cover/series/5.webp'
import img6 from '../assets/cover/series/6.webp'
import img7 from '../assets/cover/series/7.webp'
import img8 from '../assets/cover/series/8.webp'
import img9 from '../assets/cover/series/9.webp'
import img10 from '../assets/cover/series/10.webp'
import img11 from '../assets/cover/series/11.webp'
import img12 from '../assets/cover/series/12.webp'
import img13 from '../assets/cover/series/13.webp'
import img14 from '../assets/cover/series/14.webp'
import img15 from '../assets/cover/series/15.webp'
import img16 from '../assets/cover/series/16.webp'
import img17 from '../assets/cover/series/17.webp'
import img18 from '../assets/cover/series/18.webp'
import img19 from '../assets/cover/series/19.webp'
import img20 from '../assets/cover/series/20.webp'
import img21 from '../assets/cover/series/21.webp'
import img22 from '../assets/cover/series/22.webp'
import img23 from '../assets/cover/series/23.webp'
import img24 from '../assets/cover/series/24.webp'
import img25 from '../assets/cover/series/25.webp'
import img26 from '../assets/cover/series/26.webp'
import img27 from '../assets/cover/series/27.webp'
import img28 from '../assets/cover/series/28.webp'

export default function Series() {

    const movies = [
        { id: 1, image: img1, title: "El Eternauta", category: "Sci-Fi" },
        { id: 2, image: img2, title: "Man vs Baby", category: "Comedia" },
        { id: 3, image: img3, title: "Friends", category: "Comedia" },
        { id: 4, image: img4, title: "El Grinch", category: "Animación" },
        { id: 5, image: img5, title: "Vikings", category: "Acción" },
        { id: 6, image: img6, title: "Better Call Saul", category: "Drama" },
        { id: 7, image: img7, title: "City of Shadows", category: "Acción" },
        { id: 8, image: img8, title: "Paw Patrol", category: "Animación" },
        { id: 9, image: img9, title: "Jurassic World: El Renacer", category: "Acción" },
        { id: 10, image: img10, title: "Avatar: Fuego y Ceniza", category: "Acción" },
        { id: 11, image: img11, title: "Dahmer", category: "Crimen" },
        { id: 12, image: img12, title: "Del Revés 2", category: "Animación" },
        { id: 13, image: img13, title: "From", category: "Terror" },
        { id: 14, image: img14, title: "Oppenheimer", category: "Drama" },
        { id: 15, image: img15, title: "Spider-Man: Cruzando el Multiverso", category: "Animación" },
        { id: 16, image: img16, title: "La Casa de Papel", category: "Acción" },
        { id: 17, image: img17, title: "Shutter Island", category: "Suspense" },
        { id: 18, image: img18, title: "Titanic", category: "Drama" },
        { id: 19, image: img19, title: "Juego de Tronos", category: "Fantasía" },
        { id: 20, image: img20, title: "Respira", category: "Drama Médico" },
        { id: 21, image: img21, title: "Hunter x Hunter", category: "Animación" },
        { id: 22, image: img22, title: "Arcane", category: "Animación" },
        { id: 23, image: img23, title: "Rick y Morty", category: "Animación" },
        { id: 24, image: img24, title: "The Good Doctor", category: "Drama Médico" },
        { id: 25, image: img25, title: "Stranger Things", category: "Ciencia Ficción" },
        { id: 26, image: img26, title: "Vis a Vis", category: "Drama" },
        { id: 27, image: img27, title: "IT: Bienvenidos a Derry", category: "Terror" },
        { id: 28, image: img28, title: "Respira", category: "Drama Médico" }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % movies.length);
    }, [movies.length]);

    // Auto-rotation toutes les 2 secondes
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 2000);

        return () => clearInterval(interval);
    }, [nextSlide]);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + movies.length) % movies.length);
    };

    const getVisibleMovies = () => {
        const result = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % movies.length;
            result.push(movies[index]);
        }
        return result;
    };

    function importAll(requireContext) {
        return requireContext.keys().map((key) => ({ key, src: requireContext(key) }));
    }

    // Channel logos (auto import and sort alphabetically)
    const channelContext = require.context('../assets/cover/chaine', false, /\.(webp|png|jpe?g|svg)$/);
    const channelImagesSorted = importAll(channelContext)
        .sort((a, b) => a.key.localeCompare(b.key))
        .map((x) => x.src);

    // Duplicate as well for marquee continuity
    const channelImagesLoop = [...channelImagesSorted, ...channelImagesSorted];

    return (
        <section className="pb-8">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="mt-10 md:mt-0">
                    <div className="flex items-center justify-between mb-8 mt-0 md:mt-8 relative">
                        <h2 className="text-xl md:text-4xl lg:text-5xl font-bold text-white text-left -ml-4 sm:-ml-5 md:-ml-6 lg:-ml-8">VOD & Films en Vedette</h2>
                        <div className="flex gap-2 md:gap-4 absolute right-0">
                            <button 
                                onClick={prevSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-black/10 backdrop-blur-md border border-black/20 flex items-center justify-center text-white hover:bg-orange-200 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            <button 
                                onClick={nextSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-black/10 backdrop-blur-md border border-black/20 flex items-center justify-center text-white hover:bg-orange-200 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    {/* Carousel Film Container */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 overflow-hidden min-h-[320px] w-[105%] -ml-[2.5%]">
                        <AnimatePresence mode='popLayout' initial={false}>
                            {getVisibleMovies().map((movie, index) => (
                                <motion.div
                                    layout
                                    key={movie.id}
                                    initial={{ opacity: 0, scale: 0.8, x: 100 }}
                                    animate={{ opacity: 1, scale: 1, x: 0 }}
                                    exit={{ opacity: 0, scale: 0.8, x: -100 }}
                                    transition={{ 
                                        type: "spring",
                                        stiffness: 300,
                                        damping: 30,
                                        opacity: { duration: 0.2 }
                                    }}
                                    className={`relative group cursor-pointer overflow-hidden rounded-2xl h-64 sm:h-80 lg:h-64 ${index > 0 ? 'hidden lg:block' : ''}`}
                                >
                                    <img
                                        src={movie.image} 
                                        alt={movie.title} 
                                        className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    
                                    {/* Category Badge */}
                                    {movie.category && (
                                        <div className="absolute top-4 left-4 z-10">
                                            <div className="bg-white text-black px-3 py-1 rounded-full text-sm font-semibold">
                                                {movie.category}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                                    
                                    {/* Content */}
                                    <div className="absolute bottom-0 left-0 p-4 text-white w-full">
                                        <h3 className="text-lg font-bold mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                                            {movie.title}
                                        </h3>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
                <ChannelCarousel/>
            </div>
        </section>
    );
}
